/**
 * Developer Audit Logs tab — coming soon placeholder.
 */

import { createFileRoute } from "@tanstack/react-router";
import { FileText } from "lucide-react";

export const Route = createFileRoute("/_dashboard/developer/logs")({
	component: DeveloperLogsPage,
});

function DeveloperLogsPage() {
	return (
		<div className="flex flex-col items-center justify-center gap-4 py-20 text-center">
			<div className="rounded-full bg-muted p-4">
				<FileText className="size-8 text-muted-foreground" />
			</div>
			<div className="space-y-1">
				<h3 className="text-lg font-semibold">Audit Logs</h3>
				<p className="text-sm text-muted-foreground">Coming soon</p>
			</div>
			<p className="max-w-md text-sm text-muted-foreground">
				Audit logs will track all API activity — teammate creation, run execution, trigger
				modifications, and more. Every action will include timestamps, user context, and request
				metadata.
			</p>
		</div>
	);
}
